import React from 'react';
import '../style/AwaitingInput.css';

const AwaitingInput = ({ title = "Coming Soon", message = "This page is under construction." }) => {
  return (
    <div className="awaiting-input-container">
      <h1 className="awaiting-title">{title}</h1>
      <p className="awaiting-message">{message}</p>
    </div>
  );
};

export default AwaitingInput;
